import { render, staticRenderFns } from "./FavoriteModule.vue?vue&type=template&id=2f8ba822&scoped=true&"
import script from "./FavoriteModule.vue?vue&type=script&lang=js&"
export * from "./FavoriteModule.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteModule.vue?vue&type=style&index=0&id=2f8ba822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8ba822",
  null
  
)

export default component.exports